const IntlOpts = Intl.DateTimeFormat().resolvedOptions()

export function getDefaultTimezone () {
  return IntlOpts.timeZone
}

/**
 * This should only be used as suggestion when no regionCode cookie found.
 */
export function getDefaultRegion () {
  if (IntlOpts.timeZone.startsWith('Europe')) {
    return 'eu'
  } else if (IntlOpts.timeZone.startsWith('America')) {
    return 'us'
  } else if (IntlOpts.timeZone.startsWith('Australia')) {
    return 'au'
  } else {
    // Default region for other timezone
    return 'au'
  }
}

export function getClientRegionCode (newRegionCode) {
  let regionCode
  if (newRegionCode) {
    // Use regionCode from user's input
    regionCode = newRegionCode
  }
  if (!regionCode) {
    // Use regionCode from address bar
    const searchParams = new URLSearchParams(window.location.search)
    regionCode = searchParams.get('regionCode')
  }
  if (!regionCode) {
    // Use regionCode from storage
    regionCode = window.localStorage.getItem('instalinkRegionCode')
  }
  return regionCode
}

export function getSiteRegion () {
  // E.g. - https://instalink-beta.bgtdevhub.com/us/api
  //      - https://instalink-beta.bgtdevhub.com/api
  const apiUrl = new URL(process.env.REACT_APP_INSTALINK_API_URL)
  const urlParts = apiUrl.pathname.split('/')
  if (urlParts.length > 2) {
    // ['', 'us', 'api']
    return urlParts[1]
  } else {
    // ['', 'api']
    return ''
  }
}
